import { render, staticRenderFns } from "./RecognisePerson.vue?vue&type=template&id=6c52d2c3&"
import script from "./RecognisePerson.vue?vue&type=script&lang=js&"
export * from "./RecognisePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports